//@ts-nocheck
import { CreditCard } from "lucide-react";
import { useEffect, useState } from "react";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { CrossIcon, ExclamationIcon } from "../../../../components/icons/Icons";
import { useAppDispatch } from "../../../../app/hooks";
import { useParams } from "react-router-dom";
import { fetchBilling, fetchPlan, updateBillingData } from "../../../billing/BillingSlice";
import { differenceInCalendarDays, format } from "date-fns";
import { toast } from "sonner";

// Define CheckIcon as a functional component
const CheckIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      className="h-5 w-5 flex-none text-green-600"
    >
      <path
        d="M9.307 12.248a.75.75 0 1 0-1.114 1.004l1.114-1.004ZM11 15.25l-.557.502a.75.75 0 0 0 1.15-.043L11 15.25Zm4.844-5.041a.75.75 0 0 0-1.188-.918l1.188.918Zm-7.651 3.043 2.25 2.5 1.114-1.004-2.25-2.5-1.114 1.004Zm3.4 2.457 4.25-5.5-1.187-.918-4.25 5.5 1.188.918Z"
        fill="currentColor"
      />
      <circle
        cx={12}
        cy={12}
        r="8.25"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};


export default function BillingPlan() {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [billingInfo, setBillingInfo] = useState({
    name: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    taxId: "",
    // plan: "Trial",
    // nextBillDate: "N/A",
    // price: "$0/month",
    // currency: "Dollar"
  });
  const [isLoading, setIsLoading] = useState(true);


  const [formData, setFormData] = useState({ ...billingInfo });
  const [planChangeModal, setPlanChangeModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState('Annually');
  const [price, setPrice] = useState('$0/month');
  const { baseId } = useParams<{ baseId: string }>();
  const [billingDetails, setBillingDetails] = useState(null)
  const dispatch = useAppDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [planDetails, setPlanDetails] = useState(null)

  useEffect(() => {
    const tabs = [
      { name: 'Annually', href: '#', current: selectedTab === 'Annually', price: '$220' },
      { name: 'Monthly', href: '#', current: selectedTab === 'Monthly', price: '$450' },
    ];

    const selectedTabInfo = tabs.find(tab => tab.name === selectedTab);
    if (selectedTabInfo) {
      setPrice(selectedTabInfo.price);
    }
  }, [selectedTab]);




  const openEditModal = () => {
    setFormData({ ...billingInfo });
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Updated handleSubmit function to use the updateBillingData API
  const handleSubmit = async () => {

    if (!baseId || !formData.id) {
      console.error("Missing baseId or billingId for update");
      return;
    }

    setIsSubmitting(true);
    try {
      // Prepare the payload in the format expected by the API
      const updatePayload = {
        payload: {
          base_legal_name: formData.name,
          base_address: formData.address,
          base_state: formData.state,
          base_country: formData.country,
          base_pincode: formData.pincode,
          base_tax_id: formData.taxId,
          base_city: formData.city

        },
        baseId: parseInt(baseId),
        id: formData.id
      };

      // Dispatch the update billing action
      const response = await dispatch(updateBillingData(updatePayload));

      if (response.payload && response.payload.status === 200) {
        // Update local state with the updated data
        setBillingInfo({ ...formData });
        toast.success("Billing information updated successfully")
        // Close the modal
        setIsEditModalOpen(false);

        // Optionally, you could re-fetch the data to ensure it's in sync with the server
        // await dispatch(fetchBilling({ baseId }));
      } else {
        // Handle error case
        console.error("Failed to update billing information:", response.payload);
        // You might want to show an error message to the user
      }
    } catch (error) {
      console.error("Error updating billing information:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handlePlanChange = () => {
    setPlanChangeModal(true);
    // Handle plan change logic here

  }

  const closePlanChangeModal = () => {
    setPlanChangeModal(false);
  };


  // Function to fetch billing data
  useEffect(() => {
    if (baseId) {
      const fetchBillingData = async () => {
        setIsLoading(true);
        try {
          // Call the fetchBilling async thunk
          const response = await dispatch(fetchBilling({ baseId }));

          // Check if we got a valid response
          if (response.payload && response.payload.status === 200) {
            const billingData = response.payload.data;
            // Map the API response to our state structure
            setBillingInfo({
              name: billingData.base_legal_name,
              address: billingData.base_address,
              city: billingData.base_city,
              state: billingData.base_state,
              country: billingData.base_country,
              pincode: billingData.base_pincode,
              taxId: billingData.base_tax_id,
              id: billingData?.id,
              basePlanId: billingData?.base_plan_id,
              currency: billingData.base_currency,
              nextBill: billingData?.next_bill_date

              // plan: billingData.billing_status ? 
              //   billingData.billing_status.charAt(0).toUpperCase() + billingData.billing_status.slice(1) : 
              //   "Trial",
              // nextBillDate: billingData.next_bill_date ? 
              //   new Date(billingData.next_bill_date).toLocaleDateString() : 
              //   "N/A",
              // price: billingData.billing_status === "trial" ? "$0/month" : "$100/month",
              // currency: billingData.base_currency || "Dollar"
            });

            // Also update form data for the modal
            setFormData({
              name: billingData.base_legal_name,
              address: billingData.base_address,
              city: billingData.base_city,
              state: billingData.base_state,
              country: billingData.base_country,
              pincode: billingData.base_pincode,
              taxId: billingData.base_tax_id,
              basePlanId: billingData?.base_plan_id,
              currency: billingData.base_currency,
              id: billingData?.id,
              nextBill: billingData?.next_bill_date
              // plan: billingData.billing_status || "trial",
              // nextBillDate: billingData.next_bill_date || "N/A",
              // price: billingData.billing_status === "trial" ? "$0/month" : "$100/month",
              // currency: billingData.base_currency || "Dollar"
            });
          }
        } catch (error) {
          console.error("Error fetching billing details:", error);
        } finally {
          setIsLoading(false);
        }
      };

      fetchBillingData();
    }
  }, [dispatch, baseId]);

  //fetch plan


  useEffect(() => {
    if (billingInfo?.basePlanId) {
      const fetchData = async () => {
        try {
          const baseResponse = await dispatch(fetchPlan({ id: billingInfo?.basePlanId, currency: billingInfo?.currency }));
          setPlanDetails(baseResponse.payload.data.data)
        } catch (error) {
          console.error("Error fetching base member details:", error);
        }
      };
      fetchData();
    }
  }, [billingInfo?.basePlanId, dispatch]);

  return (
    <div className="w-full mx-auto bg-white rounded-lg">
      <div className="flex items-center justify-between gap-y-[6px]">
        <div className='flex flex-col gap-y-1 w-full'>
          <h2 className='text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]'>
            Billing & Subscription
          </h2>
          <p className='text-sm leading-5 text-[#5c5c5e] font-medium'>
            Manage your current plan, view past invoices, and update your payment information.
          </p>
        </div>

      </div>

      <div className="bg-[#e0e0e0] w-full h-[1px] my-8"></div>
      {isLoading ? (
        <div className="flex items-center justify-center relative z-50" style={{ height: 'calc(100vh - 391px)' }}>
          <div className="simple-spinner-loader">
            <span></span>
          </div>
        </div>
      ) : billingInfo.length === 0 ? (
        <div className='w-full mt-5 flex h-[100px] justify-center items-center flex-col gap-y-3'>
          <ExclamationIcon />
          <p className='text-[#0000007a] text-[13px]'>No results found</p>
        </div>
      ) : (
        <>
          {/* Active Plan Section */}
          <div className="mb-8">
            <div className="flex justify-between items-center mb-2">
              <div className="text-[#5c5c5e] text-sm">Active Plan</div>
              <button className="text-[#5c5c5e] text-sm" onClick={handlePlanChange}>Change Plan</button>
            </div>
            <div className="border  text-[0.875rem] py-[11.4px] w-full  border-[#0009321f] rounded-lg mt-4">
              {
                planDetails?.plan_name &&
                <h2 className="text-lg font-semibold text-gray-800 px-[11.4px] capitalize">{planDetails?.plan_name}</h2>
              }

              <p className="text-gray-400 px-[11.4px]">
                {
                  planDetails?.currency === "Dollar" &&
                  <span>$</span>
                }
                {
                  planDetails?.currency === "INR" &&
                  <span>INR</span>
                }
                {
                  planDetails?.price && !isNaN(Number(planDetails.price)) && (
                    <span>
                      {Number(planDetails.price) % 1 === 0
                        ? Number(planDetails.price) // integer like 4.00 → 4
                        : Number(planDetails.price)}</span>
                  )
                }

                {
                  planDetails?.plan_duration &&
                  <span className=" capitalize">
                    /{planDetails?.plan_duration}
                  </span>
                }
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mt-3 mb-[14px]">
                <div className="px-[11.4px] text-center py-[11.4px] bg-[#f9fafa] dashboard-card-main border-light-gray-200 border-solid border-l border-t border-b flex flex-col items-start gap-y-2 inside-card">
                  <div className="text-[0.8125rem] font-medium text-gray-500 leading-4">
                    Members
                  </div>
                  <div className="flex items-center gap-2 mt-[2px]">
                    <div className="text-[18px] font-semibold text-[#000000eb]">{planDetails?.member}</div>

                    <div className="mx-[6px] w-[1px] h-[20px] bg-gray-400 block"></div>
                    <div className="text-[18px] font-semibold text-[#000000eb]">16</div>

                  </div>
                </div>
                <div className="px-[11.4px] py-[11.4px] bg-[#f9fafa] dashboard-card-main border-light-gray-200 border-solid border-l border-t border-b flex flex-col items-start gap-y-2 inside-card">
                  <div className="text-[0.8125rem] font-medium text-gray-500 leading-4">
                    AI run
                  </div>
                  <div className="flex items-center gap-2 mt-[2px]">
                    <div className="text-[18px] font-semibold text-[#000000eb]">{planDetails?.ai_runs}</div>

                    <div className="mx-[6px] w-[1px] h-[20px] bg-gray-400 block"></div>
                    <div className="text-[18px] font-semibold text-[#000000eb]">16</div>

                  </div>
                </div>
                <div className="px-[11.4px] py-[11.4px] bg-[#f9fafa] dashboard-card-main border-light-gray-200 border-solid border-l border-t border-b flex flex-col items-start gap-y-2 inside-card">
                  <div className="text-[0.8125rem] font-medium text-gray-500 leading-4">
                    Applications
                  </div>
                  <div className="flex items-center gap-2 mt-[2px]">
                    <div className="text-[18px] font-semibold text-[#000000eb]">{planDetails?.application}</div>

                    <div className="mx-[6px] w-[1px] h-[20px] bg-gray-400 block"></div>
                    <div className="text-[18px] font-semibold text-[#000000eb]">16</div>

                  </div>
                </div>
                <div className="px-[11.4px] py-[11.4px] bg-[#f9fafa] dashboard-card-main border-light-gray-200 border-solid border-l border-t border-b flex flex-col items-start gap-y-2 inside-card">
                  <div className="text-[0.8125rem] font-medium text-gray-500 leading-4">
                    Jobs
                  </div>
                  <div className="flex items-center gap-2 mt-[2px]">
                    <div className="text-[18px] font-semibold text-[#000000eb]">{planDetails?.jobs}</div>

                    <div className="mx-[6px] w-[1px] h-[20px] bg-gray-400 block"></div>
                    <div className="text-[18px] font-semibold text-[#000000eb]">16</div>

                  </div>
                </div>

              </div>


              <p className="text-gray-600 text-sm px-[11.4px]">
                {billingInfo?.nextBill ? (
                  <>
                    Next Billing date: {format(new Date(billingInfo.nextBill), 'dd MMM yyyy')} (
                    due in {differenceInCalendarDays(new Date(billingInfo.nextBill), new Date())} days)
                  </>
                ) : (
                  'Next Billing date: N/A'
                )}
              </p>
            </div>
          </div>

          {/* Billing Settings Section */}
          <div className="mb-8">
            <div className="flex justify-between items-center mb-4">
              <div className="text-[#5c5c5e] text-sm">Billing Settings</div>
              <button className="text-[#5c5c5e] text-sm" onClick={openEditModal}>Edit</button>
            </div>

            <div className="border  text-[0.875rem] px-[11.4px] py-[11.4px] w-full  border-[#0009321f] rounded-lg mt-4">
              <div className="grid grid-cols-2 gap-2">
                <div className="text-gray-600 text-sm">Organization:</div>
                <div className="text-gray-600 text-sm capitalize">{billingInfo.name}</div>

                <div className="text-gray-600 text-sm">Address:</div>
                <div className="text-gray-600 text-sm capitalize">{billingInfo.address}</div>

                <div className="text-gray-600 text-sm">City:</div>
                <div className="text-gray-600 text-sm capitalize">{billingInfo.city}</div>

                <div className="text-gray-600 text-sm">State:</div>
                <div className="text-gray-600 text-sm capitalize">{billingInfo.state}</div>

                <div className="text-gray-600 text-sm">Country:</div>
                <div className="text-gray-600 text-sm capitalize">{billingInfo.country}</div>

                <div className="text-gray-600 text-sm">Pincode:</div>
                <div className="text-gray-600 text-sm capitalize">{billingInfo.pincode}</div>

                <div className="text-gray-600 text-sm">Tax ID:</div>
                <div className="text-gray-600 text-sm capitalize">{billingInfo.taxId}</div>
              </div>
            </div>
          </div>

          {/* Payment Method Section */}
          <div>
            <div className="text-[#5c5c5e] text-sm mb-4">Payment Method</div>
            <div className="border  text-[0.875rem] px-[11.4px] py-[11.4px] w-full  border-[#0009321f] rounded-lg mt-4">
              <div className="flex items-center">
                <CreditCard className="text-[#5c5c5e] mr-3" size={20} />
                <div className="text-gray-600">Stripe:</div>
                <div className="text-gray-600 ml-2">Connected</div>
              </div>
            </div>
          </div>

        </>
      )}





      {/* Edit Modal */}
      {isEditModalOpen && (
        <Dialog open={isEditModalOpen} onClose={setIsEditModalOpen} className="relative z-10">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <h3 className='text-base font-semibold leading-6 text-gray-900'>Edit Billing Information</h3>
                <div className="absolute right-[8px] top-[8px] hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    onClick={() => setIsEditModalOpen(false)}
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    <span className="sr-only">Close</span>
                    <CrossIcon aria-hidden="true" className="size-6" />
                  </button>
                </div>
                <div className="mt-5">
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm text-gray-700 mb-1">Name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="flex w-full grow border px-3 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] focus:ring-indigo-500 transition-colors
                        duration-100 placeholder:text-surface-500 outline-indigo-600 focus:outline focus:outline-1 focus:-outline-offset-1 bg-background text-text-100
                         hover:border-[#a9a9bc] dark:hover:border-surface-200 border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                      />
                    </div>

                    <div>
                      <label className="block text-sm text-gray-700 mb-1">Address</label>
                      <input
                        type="text"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        className="flex w-full grow border px-3 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] focus:ring-indigo-500 transition-colors
                        duration-100 placeholder:text-surface-500 outline-indigo-600 focus:outline focus:outline-1 focus:-outline-offset-1 bg-background text-text-100
                         hover:border-[#a9a9bc] dark:hover:border-surface-200 border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                      />
                    </div>

                    <div>
                      <label className="block text-sm text-gray-700 mb-1">City</label>
                      <input
                        type="text"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        className="flex w-full grow border px-3 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] focus:ring-indigo-500 transition-colors
                        duration-100 placeholder:text-surface-500 outline-indigo-600 focus:outline focus:outline-1 focus:-outline-offset-1 bg-background text-text-100
                         hover:border-[#a9a9bc] dark:hover:border-surface-200 border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                      />
                    </div>

                    <div>
                      <label className="block text-sm text-gray-700 mb-1">State</label>
                      <input
                        type="text"
                        name="state"
                        value={formData.state}
                        onChange={handleChange}
                        className="flex w-full grow border px-3 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] focus:ring-indigo-500 transition-colors
                        duration-100 placeholder:text-surface-500 outline-indigo-600 focus:outline focus:outline-1 focus:-outline-offset-1 bg-background text-text-100
                         hover:border-[#a9a9bc] dark:hover:border-surface-200 border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                      />
                    </div>

                    <div>
                      <label className="block text-sm text-gray-700 mb-1">Country</label>
                      <input
                        type="text"
                        name="country"
                        value={formData.country}
                        onChange={handleChange}
                        className="flex w-full grow border px-3 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] focus:ring-indigo-500 transition-colors
                        duration-100 placeholder:text-surface-500 outline-indigo-600 focus:outline focus:outline-1 focus:-outline-offset-1 bg-background text-text-100
                         hover:border-[#a9a9bc] dark:hover:border-surface-200 border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                      />
                    </div>

                    <div>
                      <label className="block text-sm text-gray-700 mb-1">Pincode</label>
                      <input
                        type="text"
                        name="pincode"
                        value={formData.pincode}
                        onChange={handleChange}
                        className="flex w-full grow border px-3 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] focus:ring-indigo-500 transition-colors
                        duration-100 placeholder:text-surface-500 outline-indigo-600 focus:outline focus:outline-1 focus:-outline-offset-1 bg-background text-text-100
                         hover:border-[#a9a9bc] dark:hover:border-surface-200 border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                      />
                    </div>

                    <div>
                      <label className="block text-sm text-gray-700 mb-1">Tax ID</label>
                      <input
                        type="text"
                        name="taxId"
                        value={formData.taxId}
                        onChange={handleChange}
                        className="flex w-full grow border px-3 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] focus:ring-indigo-500 transition-colors
                        duration-100 placeholder:text-surface-500 outline-indigo-600 focus:outline focus:outline-1 focus:-outline-offset-1 bg-background text-text-100
                         hover:border-[#a9a9bc] dark:hover:border-surface-200 border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex justify-end mt-6 space-x-3">
                  <button
                    type="button"
                    onClick={closeEditModal}
                    className="rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"

                  >
                    <div className="flex items-center gap-[6px]">
                      Save
                      {isSubmitting && (
                        <div className="simple-spinner">
                          <span></span>
                        </div>
                      )}
                    </div>
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      )}


      {/* plan change modal */}
      {planChangeModal && (
        <Dialog open={planChangeModal} onClose={setPlanChangeModal} className="relative z-10">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-[53rem] sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <h3 className='text-base font-semibold leading-6 text-gray-900'>Change Plan</h3>
                <div className="absolute right-[8px] top-[8px] hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    onClick={() => setPlanChangeModal(false)}
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    <span className="sr-only">Close</span>
                    <CrossIcon aria-hidden="true" className="size-6" />
                  </button>
                </div>
                <div className="mt-5">
                  <div className='mt-0'>
                    <div className="hidden w-fit relative mt-0 sm:flex border border-gray-200 rounded-full bg-gray-100 mx-auto px-2 py-0.5 space-x-0.5">
                      <button className={`z-10 flex items-center justify-center py-1.5 px-3 space-x-2.5 text-sm ${selectedTab === 'Annually' ? 'text-gray-600 ' : 'text-gray-600/70'}`} onClick={() => setSelectedTab('Annually')}>
                        <span>Annually</span>
                      </button>
                      <button className={`z-10 flex items-center justify-center py-1.5 px-3 space-x-2.5 text-sm ${selectedTab === 'Monthly' ? 'text-gray-600 ' : 'text-gray-600/70'}`} onClick={() => setSelectedTab('Monthly')}>
                        <span>Monthly</span>
                      </button>
                      <span
                        className="absolute bg-white h-[calc(100%-0.25rem)] border border-gray-200 transition-all"
                        style={{
                          left: selectedTab === 'Monthly' ? '5.3rem' : '0',
                          width: selectedTab === 'Monthly' ? '5.45rem' : '5.6rem',
                          borderRadius: selectedTab === 'Monthly' ? '1rem 2rem 2rem 1rem' : '2rem 1rem 1rem 2rem'
                        }}
                      />

                    </div>
                  </div>

                  <div className="grid  grid-cols-1 gap-5 lg:gap-2 mx-auto lg:grid-cols-2 w-full mt-5">
                    <section className="h-fit flex flex-col 
                    
                  rounded-2xl p-6 border border-gray-200/70 bg-white">
                      <h3 className="flex items-center text-gray-900 text-sm font-semibold">
                        <span>Free</span>
                      </h3>
                      <p className="relative flex tracking-tight text-gray-900 mt-5 text-3xl">
                        <span aria-hidden="true" className="space-x-1 transition">
                          <span>$0</span>
                          <span className="text-sm tracking-normal text-gray-600 ">
                            /month/project
                          </span>
                        </span>
                        <span
                          aria-hidden="true"
                          className="absolute left-0 top-0 space-x-1 pointer-events-none -translate-x-6 select-none opacity-0 transition"
                        >
                          <span>$0</span>
                          <span className="text-sm tracking-normal text-gray-600 ">
                            /month/project
                          </span>
                        </span>
                      </p>
                      <p className="mt-4 text-sm text-gray-600 ">
                        Simple and powerful
                      </p>
                      <div className="order-last mt-6">
                        <ul
                          role="list"
                          className="-my-2 divide-y text-sm divide-gray-200/60 text-[#474645] text-[16px] leading-[27px] tracking-[-0.22px]"

                        >
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">Beautiful styling out of the box</span>
                          </li>
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">Custom domain</span>
                          </li>
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">SEO-optimizations</span>
                          </li>
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">Auto-generated API docs</span>
                          </li>
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">Built-in components library</span>
                          </li>
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">Third-party analytics integrations</span>
                          </li>
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">In-app search</span>
                          </li>
                        </ul>
                      </div>
                      <button
                        className="inline-flex justify-center rounded-lg py-2 px-3 text-sm font-medium outline-2 outline-offset-2 transition-colors border border-transparent bg-neutral-800 text-white hover:bg-background-dark mt-6"

                      >
                        Get started for free
                      </button>
                    </section>
                    <section className="h-fit flex flex-col rounded-2xl p-6 border border-gray-200/70 bg-white">
                      <h3 className="flex items-center text-gray-900 text-sm font-semibold">
                        <span>Startup</span>
                      </h3>

                      <p className="relative flex tracking-tight text-black mt-5 text-3xl">
                        <span aria-hidden="true" className="space-x-1 transition">
                          <span> {price}</span>
                          <span className="text-sm tracking-normal text-gray-600">
                            /month/project
                          </span>
                        </span>
                      </p>
                      <p className="mt-4 text-sm text-gray-600">
                        Built for growing companies
                      </p>
                      <div className="order-last mt-6">
                        <ul
                          role="list"
                          className="-my-2 divide-y text-sm divide-gray-200/60 text-[#474645] text-[16px] leading-[27px] tracking-[-0.22px]">
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">The Free plan plus:</span>
                          </li>
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">Up to 5 editors</span>
                          </li>
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">Advanced analytics</span>
                          </li>
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">ChatGPT for docs</span>
                          </li>
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">Chat analytics</span>
                          </li>
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">User feedback</span>
                          </li>
                          <li className="flex py-2.5 items-center">
                            <CheckIcon />
                            <span className="ml-2  text-[#474645] text-[14px] leading-[27px] tracking-[-0.22px]">Custom subpaths /docs</span>
                          </li>

                        </ul>
                      </div>
                      <button
                        className="inline-flex justify-center rounded-lg py-2 px-3 text-sm font-medium outline-2 outline-offset-2 transition-colors relative overflow-hidden bg-green-600 text-white before:absolute before:inset-0 active:before:bg-transparent hover:before:bg-white/10 active:bg-green-600 active:text-white/80 before:transition-colors mt-6"

                      >
                        Try for free
                      </button>
                    </section>

                  </div>
                </div>

              </DialogPanel>
            </div>
          </div>
        </Dialog>


      )}

    </div>
  );
}